<template>
  <div class="content">
      <div class="nav-bar">
          <van-nav-bar
            title="Consultation"
            left-text="Back"
            :fixed="true"
            left-arrow
            :placeholder="true"
            :safe-area-inset-top="true"
             @click-left="back"
            />
          <!-- <div class="nav-one" @click="back">{{$t('other.a1279')}}</div>
          <div class="nav-two">{{$t('other.a406')}}咨询</div> -->
          <div></div>
      </div>
      <div class="service-mess" id="dialogue_box">
         <div :class="{'chat_recode_items':true,'reverse_row':item.fromUserId == uuid}" v-for="(item,index) in chatingList" :key="index">
                <div  v-if="item.messageType=='image'" :class="{'chat_desc_pic':item.fromUserId != userId,'reverse_desc_row_pic':item.fromUserId == userId}" >
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="item.content"
                        
                        fit="fit"></el-image>
                </div>
                <div v-else :class="{'chat_desc':item.fromUserId == 'thseller','reverse_desc_row':item.fromUserId == uuid}">
                  {{item.content}}
                </div>
                <div v-show="item.fromUserId == uuid" class="isRead">{{item.isRead==1 ? 'Read' : "Unread"}}</div>
              </div>
      </div>
      <div class="footer">
        <div class="flex_col">
             <el-popover
                    placement="top"
                    
                    width="300"
                    trigger="click"
                   >
                   <div >
                      <img :src="face.url" alt="" v-for="(face,index) in sticker" :key="index" style="width:60px;height:60px;cursor: pointer;" @click="sendface(face)">
                   </div>
                   <i
                      class="iconfont icon-biaoqing  left"
                      style="font-size: 20px;margin-left:20px;cursor: pointer;"
                      slot="reference"
                      
                    />
                  </el-popover>
        </div>
          <div class="flex_col">
              <div style="width:85%">
                  <van-field v-model="value" placeholder="Please enter a message"/>
              </div>
              <div style="width:15%">
                  <van-button  type="info" @click="send">Send</van-button>
              </div>
          </div>
          <!-- <div>
              发送
          </div> -->
      </div>
  </div>
</template>

<script>
import api from "../../../api/moudles/chat";
export default {
 data() {
    return {
        value:'',
        chatingList:[],
       
     uuid:'',
     userId:'',
     conversationId:'',
     sticker:[
        {
          sticker_id:"004",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/004@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0003@1x.png"
        },
        {
          sticker_id:"0008",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0008@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0003@1x.png"
        },
        {
          sticker_id:"0001",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0001@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0004@1x.png"
        },
        {
          sticker_id:"016",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/016@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0004@1x.png"
        },
        {
          sticker_id:"0002",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0002@1x.png"
        },
        {
          sticker_id:"002",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/002@1x.png"
        }
      ],
    }
  },
   created() {
    // this.getDeviceUuid();
   
    this.userId =JSON.parse(localStorage.getItem('userInfo')).userId;

    if(localStorage.getItem('uuid')==null || localStorage.getItem('uuid')==''){
        this.uuid = this.generateId();//生成一个随机唯一的标识数
        localStorage.setItem('uuid',this.uuid)
    }else{
         this.uuid = localStorage.getItem('uuid');
    }
  //  this.conversationId = localStorage.getItem('conversationId');
   
    this.connectWebsocket();
  },
  mounted(){   
    //  localStorage.setItem('uuid',this.uuid)
      console.log(this.userId);
   console.log(this.uuid);
  //  console.log(this.conversationId);
    // this.createconver();//创建会话生成会话id
    this.getUserMessage();
    
  },
  
  methods:{
    //获取客户会话列表
    getUserMessage(){
        api
        .converlist({
            userId : this.uuid
        })
        .then(res => {
            if(res.code == 'ok') {
              console.log(res);
              if(res.conversations.length!=0){
                 this.conversationId = res.conversations[0].conversationId;
                  console.log(this.conversationId);
                  this.getmessagecon();//获取会话的历史消息
              }else{
                  this.createconver();//创建会话生成会话id
              }
             
            }
			
			
        })
        

    },
     oop(){
        this.$nextTick(function(){
            this.div = document.getElementById('dialogue_box');
            this.div.scrollTop = this.div.scrollHeight;
            console.log(this.div)
             console.log('555',this.div.scrollHeight)
             console.log('444',this.div.scrollTop)
            
        })

    },
      getmessagecon(){
        api
          .getmessage({
            conversationId : this.conversationId
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
              let arr = res.messages;

            this.chatingList = arr.reverse();
            this.oop();
            this.readMessage();//将消息变为已读
            console.log(this.chatingList);
            }
            
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
      },
      readMessage(){
		console.log('messagelist',this.chatingList)

        let list=[]
        this.chatingList.forEach(p => {
            if(p.isRead === 0 && p.fromUserId != this.uuid ){
                list.push(p.messageId)
            }
        })
		
    console.log(list)
    let arrs = list.join(",");
    console.log(arrs);
    var arr = arrs.split(",");
    console.log(arr);
        if(list.length>0){
			api
        .messasread(
			{messageIds:arr}
		)
        .then(res => {
            if(res.code == 'ok') {
               
            }
        })
		}

    },//标记消息为已读
    sendface(e){
      console.log(e);
      api
          .messageinsert({
             answerUserId   : this.userId,
             conversationId : this.conversationId,
             createUserId  : this.uuid,
             fromUserId : this.uuid,
             messageContent : e.url,
             messageType : 'image',
             toUserId : this.userId
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
               
                this.getmessagecon();
                // this.oop();
            }
          
          });
    },
      send(){
        if(this.value == ''){
          this.$toast('Cannot send blank message')
        }else{
          api
          .messageinsert({
             answerUserId   : this.userId,
             conversationId : this.conversationId,
             createUserId  : this.uuid,
             fromUserId : this.uuid,
             messageContent : this.value,
             messageType : 'text',
             toUserId : this.userId
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
                // this.$toast('已发送')
                this.value = '';
                this.getmessagecon();
                // this.oop();
            }
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
        }
      },
      createconver(){
          api
          .createconver({
             answerUserId  : this.userId,
             conversationType : 'buyer',
             createUserId : this.uuid
          })
          .then((res) => {
            console.log(res);
            this.conversationId = res.conversation.conversationId;
            // localStorage.setItem('conversationId',this.conversationId);
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
      },
      generateId() {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  // bits 12-15 of the time_hi_and_version field to 0010
  s[14] = '4';
  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  const uuid = s.join('');
  return uuid;
},

      back(){
        this.$router.push({name:'iddstation',query: {userId:this.userId}})
        //  this.$router.push('/iddstation');
      },
      // H5 plus事件处理
			 getDeviceUuid() {
				var mainActivity = plus.android.runtimeMainActivity();
				var Settings = plus.android.importClass("android.provider.Settings");
				console.log("设备唯一标识为：" + Settings.Secure.getString(mainActivity.getContentResolver(), Settings.Secure.ANDROID_ID));
      },
      	//websock链接
    connectWebsocket() {
      const wsuri = "wss://m.shopsbu.com/websocket/server-endpoint/"+this.uuid;
      console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      console.log(this.websock);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log(this.$t('other.a371'));
      // this.$message.success("websock链接成功");
    },
    websocketonerror() {
      //连接建立失败重连
      // this.connectWebsocket();
      // this.$message.warning("websock链接失败,请刷新一下页面");
    },
    websocketonmessage(e) {
      //数据接收
     
      const redata =JSON.parse(e.data);
      console.log(redata);
      if(redata.type == 'erp-chat-message'){
        this.getmessagecon();
      }
      
      
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
  },


}
</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";
@media (max-width: 575px)  {

    .content{
      width: 100%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      background: #ffffff;
      .nav-bar{
          width: 100%;
          height: 5%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .nav-one{
              font-size:16px;
                font-family: PingFang SC;
                font-weight: bold;
                color:#5da2ff ;
          }
          .nav-two{
                font-size:16px;
                font-family: PingFang SC;
                font-weight: bold;
                color:#5da2ff ;
          }
      }
      .service-mess{
         height: 100%;
			width: 100%;
		
			overflow-y:scroll;
      padding-top: 1rem;
		padding-bottom: 3rem;
		box-sizing: content-box;
		
		/* 兼容iPhoneX */
		margin-bottom: 0;  
		margin-bottom: constant(safe-area-inset-bottom);  
		margin-bottom: env(safe-area-inset-bottom); 
          background: #f4f6f8;
      }
//        .customer_chat_recode{
// 		width: 450px;
// 		height: 300px;
//     border-bottom: 1px solid #EEEEEE;
//     overflow-y: auto;
//     overflow-x: hidden;
//   } 
  .chat_recode_items{
    display: flex;
			align-items: center;
			margin:10px 10px;
      font-size: 14px;
      
  }
  
  .reverse_row{
		flex-direction: row-reverse;
	}
  .chat_desc{
		max-width: 300px;
		word-wrap: break-word;
		background-color: gray;
		padding: 8px 20px;
		margin:0 0 5px 10px;
		font-family: PingFang SC;
		font-weight: bold;
		border-radius: 10px 20px 20px 0;
		color: #eee;
  }
  .reverse_desc_row{
      font-family: PingFang SC;
		font-weight: bold;
		 max-width: 300px;
		word-wrap: break-word;
		background-color: #409eff;
		padding: 8px 20px;
		margin:0 10px 5px 0px;
		color: #e5e5e5;
		border-radius: 20px 10px 0px 20px !important;
  }
  .isRead{
			font-size: 12px;
			margin-right: 10px;
		}
      .footer{
          position: fixed;
		left: 0;
        width: 100%;
        height: 7%;
		bottom: 0;
		height: auto;
		z-index: 2;
		border-top: #e5e5e5 solid 1px;
		box-sizing: content-box;
		background-color: #F3F3F3;
		
		/* 兼容iPhoneX */
		padding-bottom: 0;  
		padding-bottom: constant(safe-area-inset-bottom);  
		padding-bottom: env(safe-area-inset-bottom);  
        
      }
        }
    .talk-list{
        padding-bottom: .4rem;
    }

}
    


    /* 列式弹性盒子 */
.flex_col {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  background: #ffffff;
}
/* 行式弹性盒子 */
.flex_row {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}
/* 弹性盒子弹性容器 */
.flex_col .flex_grow{width:0;flex-grow: 1;}
.flex_row .flex_grow{flex-grow: 1;}
 
/* 弹性盒子允许换行 */
.flex_col.flex_wrap{flex-wrap: wrap;}
 
/* 弹性盒子居中对齐 */
.flex_col.flex_center,.flex_row.flex_center{justify-content: center;}
 
/* 列式弹性盒子两端对齐 */
.flex_col.flex_space{justify-content: space-between;}
</style>>

